import { PAGE_TYPE, PAYMENT_PAGE_EXTRA_TYPE } from '../../constants/analitics';
import { IServicePageInfo } from '../../types/servicePageInfo';

export function createCianAnalyticsPageViewObject({ currentStep, paymentStatus }: IServicePageInfo) {
  return {
    page: {
      pageType: PAGE_TYPE,
      extra: {
        type: paymentStatus ? PAYMENT_PAGE_EXTRA_TYPE[paymentStatus] : currentStep,
      },
    },
  };
}
